


// import React, { useState } from 'react';
// import * as XLSX from 'xlsx';
// import './table.css';

// function Table() {
//   const [sheets, setSheets] = useState([]);
//   const [selectedSheet, setSelectedSheet] = useState(null);

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];

//     if (file) {
//       const reader = new FileReader();

//       reader.onload = (e) => {
//         const data = e.target.result;
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheetNames = workbook.SheetNames;

//         const allSheetsData = sheetNames.map((sheetName) => {
//           const worksheet = workbook.Sheets[sheetName];
//           const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//           // Iterate through rows and columns and replace empty cells with empty strings
//           for (let i = 0; i < sheetData.length; i++) {
//             for (let j = 0; j < sheetData[i].length; j++) {
//               // console.log('1',sheetData[i][j])
//               if (sheetData[i][j] === null || sheetData[i][j] === undefined) {
//                 sheetData[i][j] = '&*'; // Replace empty cell with an empty string
//               }
//               // console.log('1',sheetData[i][j])
//             }
//           }

//           return sheetData;
//         });

//         setSheets(allSheetsData);
//         setSelectedSheet(0); // Select the first sheet by default
//       };

//       reader.readAsArrayBuffer(file);
//     }
//   };

//   const handleSheetClick = (index) => {
//     setSelectedSheet(index);
//   };

//   return (
//     <div>
//       <input type="file" onChange={handleFileChange} />
//       {sheets.length > 0 && (
//         <div>
//           <h2>Sheets:</h2>
//           <ul>
//             {sheets.map((sheet, index) => (
//               <li
//                 key={index}
//                 onClick={() => handleSheetClick(index)}
//                 className={selectedSheet === index ? 'selected-sheet' : ''}
//               >
//                 Sheet {index + 1}
//               </li>
//             ))}
//           </ul>
//           <h2>Data:</h2>
//           {/* <pre>{JSON.stringify(sheets[selectedSheet], null, 2)}</pre> */}
//           {/* Display the selected sheet's data in your frontend */}
//           <table className="styled-table">
//             <tbody>
//               {sheets[selectedSheet].map((row, rowIndex) => (
//                 <tr key={rowIndex}>
                  
//                   {row.map((cell, cellIndex) => (
//                     // Check if the cell is null or undefined before rendering
//                     cell !== '&*' ? (
//                       <td key={cellIndex}>{cell}</td>
//                     ) : (
//                       <td key={cellIndex}></td> // Empty cell
//                     )
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Table;






import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import './table.css';

function Table() {
  const [sheets, setSheets] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState(0);

  useEffect(() => {
    const fetchExcelData = async () => {
      try {
        const response = await fetch('http://154.61.75.57:3100/api/v2/user_modules/api/send-excel/'); // Use the correct URL for your Django API endpoint
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetNames = workbook.SheetNames;

          const allSheetsData = sheetNames.map((sheetName) => {
            const worksheet = workbook.Sheets[sheetName];
            return XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          });

          setSheets(allSheetsData);
        };

        reader.readAsArrayBuffer(blob);
      } catch (error) {
        console.error('Error fetching Excel data:', error);
      }
    };

    fetchExcelData();
  }, []);

  const handleSheetClick = (index) => {
    setSelectedSheet(index);
  };

  return (
    <div className="table-container">
      {sheets.length > 0 && (
        <div>
          <h2>Sheets:</h2>
          <ul>
            {sheets.map((sheet, index) => (
              <li
                key={index}
                onClick={() => handleSheetClick(index)}
                className={selectedSheet === index ? 'selected-sheet' : ''}
              >
                Sheet {index + 1}
              </li>
            ))}
          </ul>
          <h2>Data:</h2>
          <div className="table_container">
            <div className="table_wrapper">
              <div className="scroll-table">
                <table className="styled-table">
                  <thead>
                    <tr>
                      {sheets[selectedSheet][0].map((header, headerIndex) => (
                        <th key={headerIndex} className="excel-header">
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {sheets[selectedSheet].slice(1).map((row, rowIndex) => (
                      <tr key={rowIndex}>
{row.map((cell, cellIndex) => (
  <td key={cellIndex} className="excel-border">
    {cell !== undefined ? cell : ''}
  </td>
))}

{/* Ensure a fixed number of cells are rendered for each row */}
{[...Array(100 - row.length)].map((_, cellIndex) => (
  <td key={row.length + cellIndex} className="excel-border">
    {/* Display an empty cell for rows with fewer cells */}
  </td>
))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Table;



